export class Notification {
    // eslint-disable-next-line max-params
    constructor(
        readonly id: number,
        public aliasId: number,
        readonly alias: string,
        public dgeId: number,
        readonly dge: string,
        public sendEmail: boolean,
        readonly email: string,
        public sendSms: boolean,
        readonly phoneNumber: string
    ) { }
}

export class NotificationPartial {
    constructor(
        public aliasId: number,
        public dgeId: number,
        public sendEmail?: boolean,
        public sendSms?: boolean,
        public id?: number
    ) { }
}